import React from 'react';
const AgentAvgTimeConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/reports/agent-average-time',
			component: React.lazy(() => import('./AgentAvgTime'))
		},
	]
};

export default AgentAvgTimeConfig;
